import moment from 'moment';
import { defaultConfig } from 'scenes/common/api/config/defaults';
import { getApiData, hasData } from 'scenes/common/helpers/apiData';
import { ApiData, Config, FunnelType } from 'scenes/common/types';

export const isUnderMaintenance = (
  config: ApiData<Config>,
  product: FunnelType
): boolean => {
  if (hasData(config)) {
    if (getApiData(config).productsUnderMaintenance.length > 0) {
      return (
        getApiData(config).productsUnderMaintenance.includes(product) &&
        getApiData(config).underMaintenance
      );
    }
    return getApiData(config).underMaintenance;
  }
  return defaultConfig.underMaintenance;
};

export const isCCMaintenance = (config: ApiData<Config>): boolean =>
  hasData(config)
    ? getApiData(config).ccMaintenance
    : defaultConfig.ccMaintenance;

export const getEffectiveEndDate = (config: ApiData<Config>): string =>
  hasData(config)
    ? getApiData(config).effectiveEndDate
    : defaultConfig.effectiveEndDate;

export const isBeforeEffectiveEndDate = (
  config: ApiData<Config>,
  polocyStartDate?: string
): boolean =>
  moment(polocyStartDate).isBefore(moment(getEffectiveEndDate(config)));
